import { useEffect, useState } from 'react';
import { runAfterFirstPaint } from '../lib/runAfterFirstPaint';

/** True once LCP has fired (or a fallback timeout elapses). Gates non-critical hero motion. */
export function useLcpReady(fallbackMs = 4000): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (ready) return;

    let done = false;
    const markReady = () => {
      if (done) return;
      done = true;
      setReady(true);
    };

    const fallback = window.setTimeout(markReady, fallbackMs);

    if (typeof PerformanceObserver === 'undefined') {
      runAfterFirstPaint(markReady);
      return () => clearTimeout(fallback);
    }

    let observer: PerformanceObserver | undefined;
    try {
      observer = new PerformanceObserver((list) => {
        if (list.getEntries().length > 0) markReady();
      });
      observer.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch {
      runAfterFirstPaint(markReady);
    }

    return () => {
      clearTimeout(fallback);
      observer?.disconnect();
    };
  }, [fallbackMs, ready]);

  return ready;
}
